/**
 * Pure, platform-free fallback used until `configureInstallEnvironment` runs (or in a test
 * harness that never calls it). Touches no browser global, so it's safe to define inside
 * `client/ui` itself (boundary rule B2). Never installable, never standalone, no prompts
 * ever fire — mirrors `@econ-v1/ports`'s own `createNullInstallEnvironment()` (which this
 * file can't import directly, per B2 — `client/ui` only sees `@econ-v1/rpc`).
 */
const NOOP_INSTALL_ENVIRONMENT = {
    isStandalone: () => false,
    instructionMode: () => "unsupported",
    onInstallAvailable: () => () => undefined,
    promptInstall: async () => "unavailable",
    onAppInstalled: () => () => undefined,
    checkAlreadyInstalled: async () => false,
};
let activeInstallEnvironment = NOOP_INSTALL_ENVIRONMENT;
/**
 * Registers the real `InstallEnvironmentPort` implementation. Mirrors
 * `../theme-environment.ts`'s `configureThemeEnvironment` exactly — a module-level slot
 * inside `client/ui`, populated once by the composition root (`system/pwa/src/main.ts`, via
 * `createBrowserInstallEnvironment()` from `@econ-v1/adapters-web`) before
 * `<node-install-landing>` is inserted into the document. `client/ui` itself never
 * references `beforeinstallprompt`/`appinstalled`/`navigator.standalone`; only the injected
 * port does.
 */
export function configureInstallEnvironment(env) {
    activeInstallEnvironment = env;
}
/** Read by `install-landing.ts` as its default `installEnvironment` fallback — exported
 * separately so tests can pass a fake directly instead of mutating this shared singleton. */
export function currentInstallEnvironment() {
    return activeInstallEnvironment;
}
/** Resets the shared singleton back to the pure no-op environment. Test-only hygiene so one
 * suite's `configureInstallEnvironment` registration can never leak into another. */
export function resetInstallEnvironmentForTests() {
    activeInstallEnvironment = NOOP_INSTALL_ENVIRONMENT;
}
//# sourceMappingURL=install-environment.js.map